// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3DXsT","overflowing":"ReadFullNote_overflowing__q-oLf"};